import { render, staticRenderFns } from "./PartnersSkeletonBox.vue?vue&type=template&id=52459b9e"
import script from "./PartnersSkeletonBox.vue?vue&type=script&lang=js"
export * from "./PartnersSkeletonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports